export const getProductTax = (event: {
  product_tax?: number | string | null;
  tax?: number | string | null;
} | null | undefined): number => {
  if (event?.product_tax != null && event.product_tax !== '') {
    const n = Number(event.product_tax);
    return Number.isNaN(n) ? 0 : n;
  }
  const fallback = Number(event?.tax);
  return Number.isNaN(fallback) ? 0 : fallback;
};

export const getProductCurrency = (event: {
  product_currency?: string | null;
  currency?: string | null;
} | null | undefined): string => {
  const product = event?.product_currency;
  if (product != null && String(product).trim() !== '') {
    return String(product).trim().toLowerCase();
  }
  const booth = event?.currency;
  return booth ? String(booth).trim().toLowerCase() : 'gbp';
};

export const getCurrencySymbol = (currency: string): string => {
  switch (currency?.toLowerCase()) {
    case 'gbp':
      return '£';
    case 'usd':
      return '$';
    case 'eur':
      return '€';
    default:
      return '£';
  }
};

export const formatProductCurrencyLabel = (event: any): string => {
  const code = getProductCurrency(event).toUpperCase();
  const symbol = getCurrencySymbol(getProductCurrency(event));
  const usesProductOverride =
    (event?.product_currency != null && String(event.product_currency).trim() !== '');
  const suffix = usesProductOverride ? '' : ' (same as booth booking)';
  return `${symbol} ${code}${suffix}`;
};
